import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import './PrivacyPolicy.css';

const CookiePolicy: React.FC = () => {
  const { language } = useLanguage();
  const nl = language === 'nl';

  return (
    <div className="policy-page">
      <div className="policy-container">
        <h1>{nl ? 'Cookieverklaring' : 'Cookie Policy'}</h1>
        <p className="policy-updated">{nl ? 'Laatst bijgewerkt: februari 2025' : 'Last updated: February 2025'}</p>

        <section>
          <h2>{nl ? '1. Wat zijn cookies?' : '1. What are cookies?'}</h2>
          <p>
            {nl
              ? 'Cookies zijn kleine tekstbestanden die op uw apparaat worden opgeslagen om onze website goed te laten werken en het gebruik te analyseren.'
              : 'Cookies are small text files stored on your device to make the site work properly and to analyze usage.'}
          </p>
        </section>

        <section>
          <h2>{nl ? '2. Welke cookies gebruiken we?' : '2. Which cookies we use'}</h2>
          <ul>
            <li>
              <strong>{nl ? 'Noodzakelijke cookies' : 'Necessary cookies'}:</strong>{' '}
              {nl ? 'vereist voor basisfunctionaliteit (beveiliging, formulierverwerking).' : 'required for basic functionality (security, forms).'}
            </li>
            <li>
              <strong>{nl ? 'Analytische cookies (Vercel Analytics)' : 'Analytics (Vercel Analytics)'}:</strong>{' '}
              {nl ? 'gebruikt geaggregeerde en minimale data, zonder gebruikersprofielen.' : 'uses aggregated, minimal data without user profiling.'}
            </li>
          </ul>
        </section>

        <section>
          <h2>{nl ? '3. Hoe kunt u cookies beheren?' : '3. Managing cookies'}</h2>
          <ul>
            <li>{nl ? 'Browserinstellingen: blokkeer of verwijder cookies via uw browser.' : 'Browser settings: block or delete cookies via your browser.'}</li>
            <li>{nl ? 'Niet-essentiële cookies gebruiken we niet voor tracking of advertenties.' : 'We do not use non-essential cookies for ads or tracking.'}</li>
          </ul>
        </section>

        <section>
          <h2>{nl ? '4. Derden en doorgifte' : '4. Third parties and transfers'}</h2>
          <p>
            {nl
              ? 'Vercel Analytics kan gegevens verwerken binnen de EU/EER of met passende waarborgen. Wij delen geen cookie-informatie voor marketing.'
              : 'Vercel Analytics may process data within the EU/EEA or with appropriate safeguards. We do not share cookie data for marketing.'}
          </p>
        </section>

        <section>
          <h2>{nl ? '5. Bewaartermijnen' : '5. Retention'}</h2>
          <p>
            {nl
              ? 'Noodzakelijke cookies worden bewaard zolang nodig voor de werking; analytische data wordt geaggregeerd en beperkt bewaard.'
              : 'Necessary cookies persist as needed for functionality; analytics data is aggregated and retained for limited periods.'}
          </p>
        </section>

        <section>
          <h2>{nl ? '6. Contact' : '6. Contact'}</h2>
          <p>
            {nl
              ? 'Vragen? Mail ons op info@meijerknijnenberg.com.'
              : 'Questions? Email us at info@meijerknijnenberg.com.'}
          </p>
        </section>
      </div>
    </div>
  );
};

export default CookiePolicy;
